import React from 'react'
import { User } from 'types/user'

export type CurrentUser = [
  Promise<User>,
  () => Promise<User>
]

export const ContextCurrentUser = React.createContext<CurrentUser | undefined>(undefined)

export const useCurrentUser = () => {
  const context = React.useContext(ContextCurrentUser)
  if(!context)
  {
    throw new Error('useCurrentUser - no provider')
  }
  return context
}

export default useCurrentUser
